import { ApolloQueryResult, gql } from '@apollo/client';
import { apolloQuery } from '../apollo';
import { HighestSupportedApplicationMilestoneQuery } from '../gql/graphql';

export interface FeatureFlags {
  highestSupportedApplicationMilestone(dealerId: Number): Promise<ApolloQueryResult<HighestSupportedApplicationMilestoneQuery>>;
}

const featureFlagService: FeatureFlags = {
  async highestSupportedApplicationMilestone(dealerId: Number) {
    return apolloQuery(highestSupportedApplicationMilestone, { dealerId }) as Promise<ApolloQueryResult<HighestSupportedApplicationMilestoneQuery>>;
  },
};

const highestSupportedApplicationMilestone = gql`
  query highestSupportedApplicationMilestone($dealerId: Int!) {
    highestSupportedApplicationMilestone(dealerId: $dealerId)
  }
`;

export default featureFlagService;
